import * as React from "react"
import DropdownMenu from "./dropdown-menu"
import { openSourceMenu } from "./menus"

export default function OpenSourceMenu() {
  return <DropdownMenu items={openSourceMenu} />
}
